import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function manageTenantRoute(state = initialState.manangeTenants, action) {
    switch (action.type) {
        case types.SET_MANAGE_TENANT_ROUTE: return {
            ...state, ClentSideRoute: action.routeState,
        };
        case types.SET_TENANT_COMPANY_DETAILS: return {
            ...state, ClientSideComapnyData: action.Data,
        };
        case types.SET_TENANT_AFTERHOURS_DETAILS: return {
            ...state, ClientSideAfterHoursData: action.Data,
        };
        case types.SET_TENANT_ZONES_DETAILS: return {
            ...state, ClientSideZonesData: action.Data,
        };
        case types.SET_TENANT_EMPLOYEE_DETAILS: return {
            ...state, ClientSideEmployeesData: action.Data,
        }; 
        case types.SET_METER_DETAILS: return {
            ...state, ClientSideMeterData: action.Data,
        };
        case types.SET_TENANT_NORMALHOURS_DETAILS: return {
            ...state, ClientSideNormalHoursData: action.Data,
        };
        case types.SET_TENANT_FIXEDCHARGES_DETAILS: return{
            ...state, ClientSideFixedChargesData: action.Data,
        };
        default : return state; 
    }   
}
